// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbox-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 300px;
    height: 450px;
    background: white;
    border: 2px solid #6d4e36;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 9999;
  }
  
  .chatbox-header {
    background: #6d4e36;
    color: white;
    padding: 10px;
    font-weight: bold;
    text-align: center;
  }
  
  .chatbox-messages {
    flex: 1 1;
    padding: 10px;
    overflow-y: auto;
  }
  
  .chatbox-message {
    margin-bottom: 8px;
    background: #f5f5db;
    padding: 6px;
    border-radius: 6px;
  }
  
  .chatbox-input {
    display: flex;
    border-top: 1px solid #ccc;
  }
  
  .chatbox-input input {
    flex: 1 1;
    border: none;
    padding: 10px;
  }
  
  .chatbox-input button {
    background: #6d4e36;
    color: white;
    border: none;
    padding: 0 15px;
    cursor: pointer;
  }
  .chatbox-container.collapsed {
    height: auto;
    width: 200px;
  }
  
  .chatbox-header {
    background: #6d4e36;
    color: white;
    padding: 10px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  
  .chatbox-header.has-new-message {
    background: #a1462b !important;
    animation: pulse 1s infinite alternate;
  }
  
  .chatbox-toggle-icon {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  
  .chatbox-new-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    background: red;
    color: white;
    padding: 2px 6px;
    font-size: 12px;
    border-radius: 8px;
    animation: bounce 0.5s infinite alternate;
  }
  
  @keyframes bounce {
    from { transform: translateY(0); }
    to { transform: translateY(-3px); }
  }
  
  @keyframes pulse {
    from { background-color: #a1462b; }
    to { background-color: #e06e42; }
  }
  .chatbox-select {
    padding: 4px;
    font-size: 13px;
    margin: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .chatbox-badge {
    display: inline-block;
    margin-left: 10px;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: bold;
    border-radius: 6px;
    color: white;
  }
  
  .chatbox-badge-high {
    background-color: #d9534f;
  }
  
  .chatbox-badge-medium {
    background-color: #f0ad4e;
  }
  
  /* .chatbox-badge-normal {
    background-color: #5cb85c;
  } */
  .chatbox-message {
    background-color: #f5f5db;
    border-radius: 8px;
    padding: 8px 12px;
    margin-bottom: 8px;
    max-width: 100%;
    width: fit-content;
    white-space: pre-wrap; /* Permet le retour à la ligne automatique */
    word-break: break-word; /* Coupe proprement les mots trop longs */
    line-height: 1.5;
  }
  .chatbox-container {
    position: fixed;
    bottom: 0;
    right: 20px;
    width: 350px; /* 🆕 Augmente ici (ex: de 300px à 400px) */
    max-height: 95vh;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    z-index: 1000;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Chatbox.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,OAAO,wBAAwB,EAAE;IACjC,KAAK,2BAA2B,EAAE;EACpC;;EAEA;IACE,OAAO,yBAAyB,EAAE;IAClC,KAAK,yBAAyB,EAAE;EAClC;EACA;IACE,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;KAEG;EACH;IACE,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qBAAqB,EAAE,4CAA4C;IACnE,sBAAsB,EAAE,yCAAyC;IACjE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY,EAAE,2CAA2C;IACzD,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,sCAAsC;IACtC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf","sourcesContent":[".chatbox-container {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    width: 300px;\r\n    height: 450px;\r\n    background: white;\r\n    border: 2px solid #6d4e36;\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 10px rgba(0,0,0,0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    z-index: 9999;\r\n  }\r\n  \r\n  .chatbox-header {\r\n    background: #6d4e36;\r\n    color: white;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n  }\r\n  \r\n  .chatbox-messages {\r\n    flex: 1;\r\n    padding: 10px;\r\n    overflow-y: auto;\r\n  }\r\n  \r\n  .chatbox-message {\r\n    margin-bottom: 8px;\r\n    background: #f5f5db;\r\n    padding: 6px;\r\n    border-radius: 6px;\r\n  }\r\n  \r\n  .chatbox-input {\r\n    display: flex;\r\n    border-top: 1px solid #ccc;\r\n  }\r\n  \r\n  .chatbox-input input {\r\n    flex: 1;\r\n    border: none;\r\n    padding: 10px;\r\n  }\r\n  \r\n  .chatbox-input button {\r\n    background: #6d4e36;\r\n    color: white;\r\n    border: none;\r\n    padding: 0 15px;\r\n    cursor: pointer;\r\n  }\r\n  .chatbox-container.collapsed {\r\n    height: auto;\r\n    width: 200px;\r\n  }\r\n  \r\n  .chatbox-header {\r\n    background: #6d4e36;\r\n    color: white;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    position: relative;\r\n  }\r\n  \r\n  .chatbox-header.has-new-message {\r\n    background: #a1462b !important;\r\n    animation: pulse 1s infinite alternate;\r\n  }\r\n  \r\n  .chatbox-toggle-icon {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 10px;\r\n  }\r\n  \r\n  .chatbox-new-badge {\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 10px;\r\n    background: red;\r\n    color: white;\r\n    padding: 2px 6px;\r\n    font-size: 12px;\r\n    border-radius: 8px;\r\n    animation: bounce 0.5s infinite alternate;\r\n  }\r\n  \r\n  @keyframes bounce {\r\n    from { transform: translateY(0); }\r\n    to { transform: translateY(-3px); }\r\n  }\r\n  \r\n  @keyframes pulse {\r\n    from { background-color: #a1462b; }\r\n    to { background-color: #e06e42; }\r\n  }\r\n  .chatbox-select {\r\n    padding: 4px;\r\n    font-size: 13px;\r\n    margin: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .chatbox-badge {\r\n    display: inline-block;\r\n    margin-left: 10px;\r\n    padding: 2px 6px;\r\n    font-size: 11px;\r\n    font-weight: bold;\r\n    border-radius: 6px;\r\n    color: white;\r\n  }\r\n  \r\n  .chatbox-badge-high {\r\n    background-color: #d9534f;\r\n  }\r\n  \r\n  .chatbox-badge-medium {\r\n    background-color: #f0ad4e;\r\n  }\r\n  \r\n  /* .chatbox-badge-normal {\r\n    background-color: #5cb85c;\r\n  } */\r\n  .chatbox-message {\r\n    background-color: #f5f5db;\r\n    border-radius: 8px;\r\n    padding: 8px 12px;\r\n    margin-bottom: 8px;\r\n    max-width: 100%;\r\n    width: fit-content;\r\n    white-space: pre-wrap; /* Permet le retour à la ligne automatique */\r\n    word-break: break-word; /* Coupe proprement les mots trop longs */\r\n    line-height: 1.5;\r\n  }\r\n  .chatbox-container {\r\n    position: fixed;\r\n    bottom: 0;\r\n    right: 20px;\r\n    width: 350px; /* 🆕 Augmente ici (ex: de 300px à 400px) */\r\n    max-height: 95vh;\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    border-radius: 10px 10px 0 0;\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    z-index: 1000;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
